import services from "../services";

export const availableDocumentActions = {
  getAvailableDocument,
  downloadDocuments,
  getAvailableReports,
  getReportNames,
  downloadReports,
  getReportsList,
};

function getAvailableDocument(
  searchBillerFilesDto,
  setLoading,
  setBtnLoading
) {
  return services.availableDocumentService.getAvailableDocument(
    searchBillerFilesDto,
    setLoading,
    setBtnLoading
  );
}

function getReportsList(searchBillerFilesDto) {
  return services.availableDocumentService.getReportsList(searchBillerFilesDto);
}

function downloadDocuments(billerFilesDto, fileFormat, requestStartTime, props) {
  return services.availableDocumentService.downloadDocuments(
    billerFilesDto,
    fileFormat,
    requestStartTime,
    props
  );
}

function getAvailableReports(searchBillerFilesDto, setLoading) {
  return services.availableDocumentService.getAvailableReports(
    searchBillerFilesDto,
    setLoading
  );
}

function getReportNames(searchBillerFilesDto) {
  return services.availableDocumentService.getReportNames(searchBillerFilesDto);
}

function downloadReports(reportDocData, props) {
  return services.availableDocumentService.downloadReports(
    reportDocData,
    props
  );
}
